<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="card">
            <div class="card-body">
                <div class="card-text">
                    <b-row>
                        <b-col cols="12" md="2">
                            <app-form-text-input
                                type="text"
                                placeholder="Nombre"
                                v-model="filters.name"
                            />
                        </b-col>
                        <b-col cols="12" md="2">
                            <app-form-text-input
                                placeholder="Documento"
                                v-model="filters.document"
                                type="number"
                            />
                        </b-col>
                        <b-col cols="12" md="2">
                            <app-form-select-input
                                placeholder="Tipo cliente"
                                :options="clientTypes"
                                v-model="filters.clientTypeId"
                            />
                        </b-col>
                        <b-col cols="12" md="2">
                            <app-form-select-input
                                placeholder="Ciudad"
                                :options="cities"
                                v-model="filters.cityId"
                            />
                        </b-col>
                        <b-col cols="12" md="2">
                            <app-form-select-input
                                v-model="filters.executiveId"
                                :options="executives"
                                placeholder="Ejecutivo"
                            ></app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="2">
                            <button
                                @click="searchClients"
                                class="btn btn-primary btn-block-xs-only mr-2"
                            >
                                <i class="fa fa-filter"></i>
                            </button>
                            <button
                                @click="cancelFilter"
                                class="btn btn-secondary btn-block-xs-only"
                            >
                                <i class="fa fa-times-circle"></i>
                            </button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: () => ({
        filters: {
            name: '',
            document: '',
            clientTypeId: '',
            cityId: '',
            executiveId: '',
        },
        cities: [],
        clientTypes: [],
        executives: [],
    }),
    methods: {
        searchClients() {
            this.$emit('filter', this.filters)
        },
        cancelFilter() {
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.$emit('cancel-filter')
        },
        async loadClientTypes() {
            const { data } = await repo.get('clients/client-types')
            this.clientTypes = data
        },
        async loadCities() {
            const { data } = await repo.get('localization/cities')
            this.cities = data
        },
        async loadExecutives() {
            const { data } = await repo.get('users/executives')
            this.executives = data
        },
    },
    mounted() {
        this.loadClientTypes()
        this.loadCities()
        this.loadExecutives()
    },
}
</script>